import { useEffect, useState } from "react";
import axios from "axios";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./AlarmReports.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

export default function ActiveAlarmReport() {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [alarms, setAlarms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alarmTypeFilter, setAlarmTypeFilter] = useState("ALL");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const customerName = localStorage.getItem("customer_name");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");









  useEffect(() => {
    const fetchCustomers = async () => {

      // ✅ Customer Admin
      if (role === "CA" || role === "SE" ||  role === "DC") {
        setSelectedCustomer(customerId);

        // Used for PDF export
        setCustomers([
          {
            id: customerId,
            name: customerName || "Customer",
          },
        ]);

        return;
      }



      try {
        const res = await axios.get(
          `${API_URL}/api/get_customers/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const customerList = (res.data || []).map((c) => ({
          id: c.tb_customer_id,
          name: c.customer_name,
        }));

        setCustomers(customerList);

        if (customerList.length > 0) {
          setSelectedCustomer(customerList[0].id);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };

    fetchCustomers();
  }, [role, customerId]);
  // ================= FETCH SITES =================

  useEffect(() => {
    const fetchSites = async () => {
      if (!selectedCustomer) return;
      try {
        let siteItems = [];

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        };

        // SUPERVISOR
        if (role === "S") {
          const res = await axios.get(
            `${API_URL}/api/supervisor_sites/${userId}/`,
            config,
          );

          siteItems = (res.data.sites || []).map((s) => ({
            id: s.asset_id,
            name: s.name,
          }));
        }

        // SITE ENGINEER
        else if (role === "SE") {
          const res = await axios.get(
            `${API_URL}/api/engineer_sites/${userId}/`,
            config,
          );

          siteItems = (res.data.sites || []).map((s) => ({
            id: s.asset_id,
            name: s.site_name,
          }));
        }

        // CUSTOMER
        else {
          const res = await axios.get(
            `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
            config,
          );

          siteItems = (res.data.data || []).map((s) => ({
            id: s.asset_id,
            name: s.name,
          }));
        }

        setSites(siteItems);

        if (siteItems.length > 0) {
          setSelectedSite(siteItems[0].id);
        }
      } catch (err) {
        console.error("Error fetching sites:", err);
      }
    };

    fetchSites();
  }, [selectedCustomer, role, userId, token]);

  // ================= FETCH ALARMS =================

  useEffect(() => {
    const fetchAlarms = async () => {
      if (!selectedSite) return;

      setLoading(true);

      try {
        const res = await axios.get(
          `${API_URL}/api/alarm-report/${selectedSite}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: {},
          },
        );

        setAlarms(res.data.report_data || []);


      } catch (err) {
        console.error("Alarm Fetch Error:", err);
        setAlarms([]);
      }

      setLoading(false);
    };

    fetchAlarms();
  }, [selectedSite]);

  // ================= STATUS LABEL =================

  // const getStatusLabel = (status) => {
  //   const labels = {
  //     ACTIVE_UNACK: "Active / Unack",
  //     ACTIVE_ACK: "Active / Ack",
  //     CLEARED_UNACK: "Cleared / Unack",
  //     CLEARED_ACK: "Resolved",
  //   };

  //   return labels[status] || status;
  // };

  // ================= FORMAT TIME =================

  // const formatTime = (ts) => {
  //   if (!ts) return "-";
  //   return new Date(ts).toLocaleString();
  // };

  const csvEscape = (value) => {
  const str = String(value ?? "-").replace(/"/g, '""').replace(/\r?\n/g, " ");
  return `"${str}"`;
};

  // ================= CSV EXPORT =================

  const handleExportCSV = () => {

    const selectedSiteName =
      sites.find((s) => s.id === selectedSite)?.name || "Site";

    const selectedAlarmType =
      alarmTypeFilter === "ALL"
        ? "All Alarms"
        : alarmTypeFilter;

    const headers = [
      "Sr No",
      "Triggered At",
      "Cleared At",
      "Device Name",
      "Alarm Name",
      "Duration",
      "Remark",
  "Acknowledged At",
    ];
    // ✅ EXPORT FILTERED DATA ONLY
    const rows = filteredAlarms.map((a) => [
      a.sr_no,
      a.triggered_at,
      a.cleared_at,
      a.device_name,
      a.alarm_name,
      a.duration_readable,
      csvEscape(a.remark),
  a.acknowledged_at,
    ]);
    // const selectedCustomerName =
    //   role === "CA" || role === "SE"
    //     ? localStorage.getItem("customer_name") || "Customer"
    //     : customers.find((c) => c.id === selectedCustomer)?.name || "Customer";

    const selectedCustomerName =
      customers.find((c) => c.id === selectedCustomer)?.name || "Customer";

    const csvContent = [
      //  [`Customer Name:,${selectedCustomerName}`],
      ...(role !== "CA" && role !== "SE" && role !== "DC"
        ? [[`Customer Name:,${selectedCustomerName}`]]
        : []),

      [`Site Name:,${selectedSiteName}`],

      // ✅ SHOW FILTER NAME
      [`Alarm Type:,${selectedAlarmType}`],

      [],

      headers,

      ...rows,
    ]
      .map((e) => e.join(","))
      .join("\n");

    // const csv = "data:text/csv;charset=utf-8," + csvContent;

    // const link = document.createElement("a");

    // link.href = encodeURI(csv);
    const link = document.createElement("a");
link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);

    link.download =
      `${selectedCustomerName}_${selectedSiteName}_${selectedAlarmType}_alarm_report.csv`;

    link.click();
  };
  // ================= PDF EXPORT =================

  const handleExportPDF = () => {

    const selectedSiteName =
      sites.find((s) => s.id === selectedSite)?.name || "Site";

    //     const selectedCustomerName =
    // role === "CA" || role === "SE"
    //   ? localStorage.getItem("customer_name") || "Customer"
    //   : customers.find((c) => c.id === selectedCustomer)?.name || "Customer";

    const selectedCustomerName =
      customers.find((c) => c.id === selectedCustomer)?.name || "Customer";



    const selectedAlarmType =
      alarmTypeFilter === "ALL"
        ? "All Alarms"
        : alarmTypeFilter;

const doc = new jsPDF("l");

    doc.setFontSize(16);
    doc.text("Alarm Report", 14, 12);

    doc.setFontSize(12);

    let y = 18;

    if (role !== "CA" && role !== "SE" ||  role !== "DC") {
      doc.text(`Customer Name : ${selectedCustomerName}`, 14, y);
      y += 8;
    }

    doc.text(`Site Name: ${selectedSiteName}`, 14, y);
    y += 8;

    doc.text(`Alarm Type: ${selectedAlarmType}`, 14, y);

   autoTable(doc, {
  startY: y + 8,
  head: [
    [
      "Sr No",
      "Triggered At",
      "Cleared At",
      "Device Name",
      "Alarm Name",
      "Duration",
      "Remark",
      "Acknowledged At",
    ],
  ],
  body: filteredAlarms.map((a) => [
    a.sr_no,
    a.triggered_at,
    a.cleared_at,
    a.device_name,
    a.alarm_name,
    a.duration_readable,
    a.remark || "-",
    a.acknowledged_at || "-",
  ]),
  styles: { fontSize: 8 },
});

    doc.save(
      `${selectedCustomerName}_${selectedSiteName}_${selectedAlarmType}_alarm_report.pdf`
    );

  };


  {/* ================= PAGINATION ================= */ }

  // const filteredAlarms = alarms.filter((alarm) => {
  //   if (alarmTypeFilter === "ALL") {
  //     return true;
  //   }

  //   return (
  //     alarm.alarm_name?.trim().toLowerCase() ===
  //     alarmTypeFilter.trim().toLowerCase()
  //   );
  // });


  const filteredAlarms = alarms.filter((alarm) => {
    if (alarmTypeFilter === "ALL") {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

      const alarmDate = new Date(
        alarm.triggered_at.replace(" ", "T")
      );

      return alarmDate >= thirtyDaysAgo;
    }

    return (
      alarm.alarm_name?.trim().toLowerCase() ===
      alarmTypeFilter.trim().toLowerCase()
    );
  });



  const paginatedAlarms = filteredAlarms.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const totalFiltered = filteredAlarms.length;

  const startIdx =
    totalFiltered === 0 ? 0 : page * rowsPerPage + 1;

  const endIdx = Math.min(
    page * rowsPerPage + rowsPerPage,
    totalFiltered
  );


  return (
    <Box className="report-container">
      {/* TOP BAR */}

      <Box className="top-bar">

        {role !== "CA" && role !== "SE" && role !== "DC" && (
          <FormControl className="dropdown">
            <InputLabel>Customer</InputLabel>

            <Select
              value={selectedCustomer}
              label="Customer"
              onChange={(e) => {
                setSelectedCustomer(e.target.value);
                setSelectedSite("");
                setAlarms([]);
              }}
            >
              {customers.map((c) => (
                <MenuItem key={c.id} value={c.id}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl className="dropdown">
          <InputLabel>Select Site</InputLabel>

          <Select
            value={selectedSite}
            label="Select Site"
            onChange={(e) => setSelectedSite(e.target.value)}
          >
            {sites.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        <FormControl className="dropdown">
          <InputLabel>Alarm Type</InputLabel>

          <Select
            value={alarmTypeFilter}
            label="Alarm Type"
            onChange={(e) => {
              setAlarmTypeFilter(e.target.value);
              setPage(0);
            }}
          >
            <MenuItem value="ALL">All</MenuItem>

            <MenuItem value="Low Water Level">
              Low Water Level
            </MenuItem>

            <MenuItem value="Low Diesel level">
              Low Diesel level
            </MenuItem>

            <MenuItem value="Lower Hydrant Pressure Alarm">
              Lower Hydrant Pressure Alarm
            </MenuItem>

            <MenuItem value="Lower Sprinkler Pressure Alarm">
              Lower Sprinkler Pressure Alarm
            </MenuItem>

            <MenuItem value="Upper Hydrant Pressure Alarm">
              Upper Hydrant Pressure Alarm
            </MenuItem>

            <MenuItem value="Upper Sprinkler Pressure Alarm">
              Upper Sprinkler Pressure Alarm
            </MenuItem>
          </Select>
        </FormControl>

        <Box className="export-buttons">
          <Button
            onClick={handleExportCSV}
            className="btn-csv"
            disabled={!alarms.length}
          >
            CSV
          </Button>

          <Button
            onClick={handleExportPDF}
            className="btn-pdf"
            disabled={!alarms.length}
          >
            PDF
          </Button>
        </Box>
      </Box>

      {/* TABLE */}

      <TableContainer component={Paper} className="table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Triggered At</TableCell>
              <TableCell>Cleared At</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Alarm Name</TableCell>
              <TableCell>Active Duration</TableCell>
              <TableCell>Remark</TableCell>
              <TableCell>Acknowledged At</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : alarms.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No Alarm Data
                </TableCell>
              </TableRow>
            ) : (
              paginatedAlarms.map((alarm, i) => (
                <TableRow key={alarm.alarm_id}>
                  <TableCell>{alarm.sr_no}</TableCell>

                  <TableCell>
                    {alarm.triggered_at}
                  </TableCell>

                  <TableCell>
                    {alarm.cleared_at}
                  </TableCell>

                  <TableCell>
                    {alarm.device_name}
                  </TableCell>

                  <TableCell>
                    {alarm.alarm_name}
                  </TableCell>

                  <TableCell>
                    {alarm.duration_readable}
                  </TableCell>
                  <TableCell>{alarm.remark || "-"}</TableCell>
<TableCell>{alarm.acknowledged_at || "-"}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* PAGINATION */}

      <div className="pagination-bar">

        <div className="rows-select">
          Rows per page:

          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
          </select>
        </div>

        <div className="page-info">
          {startIdx}-{endIdx} of {totalFiltered}
        </div>

        <div className="page-arrows">

          <button
            disabled={page === 0}
            onClick={() => setPage(page - 1)}
          >
            ‹
          </button>

          <button
            disabled={endIdx >= totalFiltered}
            onClick={() => setPage(page + 1)}
          >
            ›
          </button>

        </div>

      </div>
    </Box>
  );
}